var exports = {
  "kL": "DiscoveryCompanionTalkPage.module__container___RnczWn",
  "wx": "DiscoveryCompanionTalkPage.module__header___RnczWn",
  "VW": "DiscoveryCompanionTalkPage.module__headerContent___RnczWn",
  "nr": "DiscoveryCompanionTalkPage.module__headerIcon___RnczWn",
  "DD": "DiscoveryCompanionTalkPage.module__title___RnczWn",
  "XG": "DiscoveryCompanionTalkPage.module__scroller___RnczWn",
  "Qs": "DiscoveryCompanionTalkPage.module__content___RnczWn",
  "uW": "DiscoveryCompanionTalkPage.module__section___RnczWn",
  "Gf": "DiscoveryCompanionTalkPage.module__sectionTitle___RnczWn",
  "$7": "DiscoveryCompanionTalkPage.module__sectionDesc___RnczWn",
  "aK": "DiscoveryCompanionTalkPage.module__hint___RnczWn",
  "jy": "DiscoveryCompanionTalkPage.module__errorBanner___RnczWn",
  "r9": "DiscoveryCompanionTalkPage.module__roleList___RnczWn",
  "Fl": "DiscoveryCompanionTalkPage.module__roleCard___RnczWn",
  "Qp": "DiscoveryCompanionTalkPage.module__roleCardDefault___RnczWn",
  "iX": "DiscoveryCompanionTalkPage.module__roleGreeting___RnczWn",
  "Mu": "DiscoveryCompanionTalkPage.module__memoryList___RnczWn",
  "Q3": "DiscoveryCompanionTalkPage.module__memoryCard___RnczWn",
  "sb": "DiscoveryCompanionTalkPage.module__memoryHead___RnczWn",
  "Gl": "DiscoveryCompanionTalkPage.module__memoryRole___RnczWn",
  "_X": "DiscoveryCompanionTalkPage.module__memoryEntries___RnczWn",
  "tt": "DiscoveryCompanionTalkPage.module__memoryTime___RnczWn",
  "qT": "DiscoveryCompanionTalkPage.module__memorySummary___RnczWn",
  "Vb": "DiscoveryCompanionTalkPage.module__roleHead___RnczWn",
  "UT": "DiscoveryCompanionTalkPage.module__roleIcon___RnczWn",
  "S3": "DiscoveryCompanionTalkPage.module__roleName___RnczWn",
  "jz": "DiscoveryCompanionTalkPage.module__defaultBadge___RnczWn",
  "Q7": "DiscoveryCompanionTalkPage.module__roleDesc___RnczWn",
  "Ml": "DiscoveryCompanionTalkPage.module__roleActions___RnczWn",
};

module.exports = exports;
